import React from 'react'

export const Footer = () => {
  return (
    <footer className='w-full bg-blue-700 text-center p-5'>
        Copyrights &#169;2025 Vasuki Elango.All right received.   
    </footer>
  )
}
